const urlName = '/course/v1/admin/course'
const urlName1 = '/course/v1/admin/courseItem/admin'
export default API => ({
    //课程列表
    findManageList({ data, params }) {
        return API({
            url: `${urlName}/findManageList` ,
            params,
            data
        });
    },
    //课程详情
    findById({ data, params }) {
        return API({
            url: `${urlName}/findById` ,
            params,
            data
        });
    },
    //课程详情
    findRaaSCourseById({ data, params }) {
        return API({
            url: `${urlName}/findRaaSCourseById` ,
            params,
            data
        });
    },
    //课程详情保存
    save({ data }) {
        return API({
            url: `${urlName}/save`,
            method:'post',
            data
        });
    },
    //目录详情
    getValidCourseItemInfo({ data, params }) {
        return API({
            url: `${urlName1}/getValidCourseItemInfo` ,
            params,
            data
        });
    },
    //课程删除
    delete({ params }) {
        return API({
            url: `${urlName}/delete`,
            method:'post',
            params
        });
    },
    //课程发布
    publish({ params }) {
        return API({
            url: `${urlName}/publish`,
            method:'post',
            params
        });
    },
    //课程发布
    cancelpublish({ params }) {
        return API({
            url: `${urlName}/cancel`,
            method:'post',
            params
        });
    },
    //课程下架
    unPublish({ params }) {
        return API({
            url: `${urlName}/unPublish`,
            method:'post',
            params
        });
    },
    coursecopy({ params }) {
        return API({
            url: `${urlName}/copy`,
            method:'post',
            params
        });
    },
    
    courseItemsave({ data }) {
        return API({
            url: `/course/v1/admin/courseItem/save`,
            method:'post',
            data
        });
    },
    saveAndPublish({ data }) {
        return API({
            url: `/course/v1/admin/courseItem/saveAndPublish`,
            method:'post',
            data
        });
    },
    findTrainListByCourseId({params }) {
        return API({
            url: `train/v1/train/findTrainListByCourseId`,
            params
        });
    },
    
})
